import React from 'react';
import { useTranslation } from 'react-i18next';
import { REFERRAL_META } from '../data/mock';
import { MapPin, ArrowUpRight } from 'lucide-react';

const Referrals = () => {
  const { t } = useTranslation();
  const items = t('referrals.items', { returnObjects: true });
  return (
    <section id="sold" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-[640px]">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#5FE0C8] mb-4">{t('referrals.eyebrow')}</div>
            <h2 className="font-display text-[44px] md:text-[60px] leading-[0.98] tracking-tight">
              {t('referrals.heading1')} <span className="font-serif-i text-[#5FE0C8]">{t('referrals.heading2')}</span>
            </h2>
          </div>
          <p className="max-w-[360px] text-[14px] text-[#9FA8A4] leading-relaxed">
            {t('referrals.intro')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {REFERRAL_META.map((meta, i) => (
            <article
              key={i}
              data-testid={`referral-card-${i}`}
              className="group relative rounded-2xl overflow-hidden panel-card hover:border-[#5FE0C8]/40 transition-all duration-300"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={meta.img}
                  alt={items[i]?.suburb}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#07120F] via-[#07120F]/30 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full text-[10.5px] tracking-[0.18em] uppercase bg-[#5FE0C8] text-[#07120F] font-medium">
                    {t('referrals.soldBadge')}
                  </span>
                </div>
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 rounded-full text-[11px] tracking-[0.16em] uppercase text-[#ECE9DF] bg-black/40 backdrop-blur-sm border border-white/15">
                    {items[i]?.type}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-[#9FA8A4] mb-2">
                    <MapPin className="w-3 h-3" />
                    {items[i]?.suburb}
                  </div>
                  <div className="font-display text-[30px] leading-none tracking-tight text-[#ECE9DF]">
                    {meta.price}
                  </div>
                </div>
              </div>
              <div className="p-5 pt-4">
                <p className="text-[13px] text-[#C9C5B8] leading-relaxed">{items[i]?.detail}</p>
                <div className="mt-4 pt-3 border-t border-white/5 flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.14em] uppercase text-[#7E8A85]">{items[i]?.client}</span>
                  <ArrowUpRight className="w-3.5 h-3.5 text-[#5FE0C8] opacity-60 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Referrals;
